/* SpecialistID - Algolia color swatches (facet sidebar + product cards + color-swap + family filter)
   1) Decorates the Color facet refinement list with color dots.
   2) Enriches deduped product cards with per-product colorway swatches.
   3) Clicking a card swatch swaps the card image / price / sku / link to that colorway.
   4) "Shop by color family" quick-pick row at the top of the Color facet: clicking a
      family (Blue, Green...) OR-selects all of its available shades at once.
   Enrichment runs one distinct:0 query mirroring the current search state
   (via is.helper.getQuery + the app's own searchClient), grouped by handle.
   Family availability uses a dedicated facet query that ignores the colour
   refinement (disjunctive-correct) so the family row never collapses or caps.
   Self-contained, ES5-safe, no external image dependencies. */
(function () {
  var DATA = {"map":{"Black":"#000000","White":"#ffffff","Gray":"#808080","Light Gray":"#d3d3d3","Metallic Gray":"#9aa0a6","Grey Brown":"#6d5f52","Silver":"#c0c0c0","Silver/Chrome":"#cfd4d8","Chrome":"#dce1e4","Gold":"#ffd700","Brown":"#964b00","Tan":"#c9a66b","Blue":"#0000ff","Royal Blue":"#4169e1","Navy Blue":"#0046bf","Light Blue":"#7fbfe8","Process Blue":"#0075c9","Reflex Blue":"#1c2f8f","Metallic Blue":"#3a5f8a","Monaco Blue":"#274b8f","Neon Blue":"#1b74ff","Green":"#008000","Dark Green":"#013220","Forest Green":"#0b3d20","Emerald Green":"#0f9d58","Lime":"#8bc34a","Military Green":"#4b5320","Neon Green":"#5bff33","Red":"#ff0000","Fire Red":"#c0110b","Maroon":"#800000","Watermelon":"#f2607a","Pink":"#ffc0cb","Hot Pink":"#ff0080","Neon Pink":"#ff4dc4","Awareness Pink":"#f7a6c4","Orange":"#ffa500","Neon Orange":"#ff6a00","Neon Orange (Antimicrobial)":"#ff6a00","Nectarine Orange":"#ff8c42","Yellow":"#ffff00","Neon Yellow":"#eaff00","Purple":"#800080","Neon Purple":"#b026ff","Lavender":"#ccccff","Teal":"#008080","Clear":"#e8f0f2","Frosted":"#dfe6e9","Translucent White (clear)":"#eef2f4","Translucent White":"#eef2f4","Translucent Blue":"#8ec5e6","Translucent Red":"#e6a3a3","Translucent Purple":"#c3a0d6","Translucent Green":"#a9d6a0","Translucent Orange":"#f0b48a","Translucent Yellow":"#eae19a","Translucent Black":"#3a3a3a","Translucent Pink":"#f3b6cf","Rainbow":"linear-gradient(90deg,red,orange,yellow,green,blue,violet)","RWB":"linear-gradient(135deg,#ff0000 33%,#ffffff 33% 66%,#0000ff 66%)","Camouflage":"radial-gradient(circle at 28% 30%,#4b5320 0 28%,transparent 29%),radial-gradient(circle at 72% 62%,#3a3f2b 0 24%,transparent 25%),#78866b","MultiCam":"radial-gradient(circle at 30% 32%,#7a6a46 0 26%,transparent 27%),radial-gradient(circle at 70% 64%,#4b4636 0 22%,transparent 23%),#a08f66","Digital Camo":"radial-gradient(circle at 30% 30%,#4b503f 0 26%,transparent 27%),radial-gradient(circle at 68% 60%,#2f3327 0 22%,transparent 23%),#6b705c","Zebra Print":"repeating-linear-gradient(60deg,#111 0 3px,#fff 3px 6px)","Floral":"radial-gradient(circle at 50% 50%,#e59bb0 0 40%,#7fae6b 41%)","Assorted":"conic-gradient(red,orange,yellow,green,blue,violet,red)","Custom":"conic-gradient(red,orange,yellow,green,blue,violet,red)"},"translucent":["Translucent White (clear)","Translucent White","Translucent Blue","Translucent Red","Translucent Purple","Translucent Green","Translucent Orange","Translucent Yellow","Translucent Black","Translucent Pink","Clear","Frosted"]};
  var MAP = DATA.map, TRANS = {}; DATA.translucent.forEach(function (k) { TRANS[k] = 1; });

  /* SPID part number for cards (2026-07-26, Patrick). Twin of the helper in
     assets/algolia-2026.js -- whichever file loads first defines it. Same
     normalisation as snippets/spid-part-number.liquid: drop the "-Q<n>"
     quantity suffix, prefix a leading 0 for Fargo. */
  var pnDisp = window.__spidPnDisp || function (sku, vendor) {
    var s = String(sku == null ? '' : sku).split('-Q')[0].replace(/^\s+|\s+$/g, '');
    if (!s) return '';
    if (String(vendor == null ? '' : vendor).toLowerCase().indexOf('fargo') !== -1 && s.charAt(0) !== '0') s = '0' + s;
    return s;
  };
  window.__spidPnDisp = pnDisp;

  /* fixed display order so swatches read consistently across cards */
  var ORDER = ['Black','White','Gray','Light Gray','Metallic Gray','Silver','Silver/Chrome','Chrome','Gold','Grey Brown','Brown','Tan',
    'Red','Fire Red','Maroon','Watermelon','Pink','Hot Pink','Neon Pink','Awareness Pink',
    'Orange','Neon Orange','Nectarine Orange','Yellow','Neon Yellow',
    'Green','Lime','Neon Green','Emerald Green','Forest Green','Dark Green','Military Green','Teal',
    'Blue','Light Blue','Royal Blue','Navy Blue','Process Blue','Reflex Blue','Monaco Blue','Metallic Blue','Neon Blue',
    'Purple','Neon Purple','Lavender',
    'Clear','Frosted','Translucent White','Translucent Black','Translucent Blue','Translucent Red','Translucent Green','Translucent Orange','Translucent Yellow','Translucent Purple','Translucent Pink',
    'Rainbow','RWB','Camouflage','Digital Camo','MultiCam','Zebra Print','Floral','Assorted','Custom'];
  function colorRank(name) { var i = ORDER.indexOf(name); return i < 0 ? 900 : i; }

  /* 16 broad colour families -> exact shade members (quick-pick filter) */
  var FAMILIES = [
    { key: 'Black', hex: '#000000', members: ['Black', 'Translucent Black'] },
    { key: 'White', hex: '#ffffff', members: ['White'] },
    { key: 'Blue', hex: '#1560ff', members: ['Blue', 'Royal Blue', 'Navy Blue', 'Light Blue', 'Process Blue', 'Reflex Blue', 'Metallic Blue', 'Monaco Blue', 'Neon Blue', 'Translucent Blue'] },
    { key: 'Red', hex: '#ff0000', members: ['Red', 'Fire Red', 'Maroon', 'Translucent Red'] },
    { key: 'Green', hex: '#008000', members: ['Green', 'Dark Green', 'Forest Green', 'Emerald Green', 'Lime', 'Military Green', 'Neon Green', 'Translucent Green'] },
    { key: 'Yellow', hex: '#ffd400', members: ['Yellow', 'Neon Yellow', 'Translucent Yellow'] },
    { key: 'Orange', hex: '#ffa500', members: ['Orange', 'Neon Orange', 'Neon Orange (Antimicrobial)', 'Nectarine Orange', 'Translucent Orange'] },
    { key: 'Purple', hex: '#800080', members: ['Purple', 'Neon Purple', 'Lavender', 'Translucent Purple'] },
    { key: 'Pink', hex: '#ff4da6', members: ['Pink', 'Hot Pink', 'Neon Pink', 'Awareness Pink', 'Translucent Pink', 'Watermelon'] },
    { key: 'Teal', hex: '#008080', members: ['Teal'] },
    { key: 'Gray', hex: '#808080', members: ['Gray', 'Light Gray', 'Metallic Gray'] },
    { key: 'Silver', hex: '#c0c0c0', members: ['Silver', 'Silver/Chrome', 'Chrome'] },
    { key: 'Gold', hex: '#c9a227', members: ['Gold'] },
    { key: 'Brown', hex: '#964b00', members: ['Brown', 'Tan', 'Grey Brown'] },
    { key: 'Clear', hex: '#e8f0f2', members: ['Clear', 'Frosted', 'Translucent White', 'Translucent White (clear)'] },
    { key: 'Multi-color', hex: 'conic-gradient(red,orange,yellow,green,blue,violet,red)', members: ['Rainbow', 'RWB', 'Camouflage', 'MultiCam', 'Digital Camo', 'Zebra Print', 'Floral', 'Assorted', 'Custom'] }
  ];

  function makeSwatch(name) {
    var v = MAP[name];
    var s = document.createElement('span');
    s.className = 'spid-swatch';
    if (!v) { s.className += ' spid-swatch--unknown'; s.title = name; return s; }
    s.style.background = v;
    if (TRANS[name]) s.className += ' spid-swatch--trans';
    s.title = name;
    return s;
  }

  /* ================= FACET SIDEBAR ================= */
  function labelText(label) {
    var t = '';
    label.childNodes.forEach(function (n) { if (n.nodeType === 3) t += n.textContent; });
    return t.trim();
  }
  function decorate() {
    var lists = [];
    document.querySelectorAll('.ais-RefinementList-list').forEach(function (l) {
      if (/Royal Blue|Navy Blue|Hot Pink|Black|Green/.test(l.textContent)) lists.push(l);
    });
    lists.forEach(function (list) {
      list.querySelectorAll('.ais-RefinementList-label').forEach(function (label) {
        if (label.querySelector('.spid-swatch')) return;
        var name = labelText(label);
        if (!name) return;
        var sw = makeSwatch(name);
        var cb = label.querySelector('input');
        if (cb) { cb.insertAdjacentElement('afterend', sw); }
        else { label.insertBefore(sw, label.firstChild); }
        label.classList.add('spid-has-swatch');
      });
    });
  }

  /* ================= CARD ENRICHMENT ================= */
  var enrichCache = {};   /* sig -> {map:{handle:[colorways]}, colors:{}} */
  var enriching = {};     /* sig -> true while in flight */

  function assign(t, s) { for (var k in s) { if (Object.prototype.hasOwnProperty.call(s, k)) t[k] = s[k]; } return t; }
  /* shared with assets/algolia-2026.js -- whichever file loads first defines it.
     Matches the Liquid `money` filter's shape (thousands separators). */
  var money = window.__spidMoney || function (n) {
    n = Number(n);
    if (!isFinite(n)) n = 0;
    var p = n.toFixed(2).split('.');
    return '$' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + p[1];
  };
  window.__spidMoney = money;

  /* ---------- MAP / MAPP guard (2026-07-28, Patrick) ----------
     Same object as assets/algolia-2026.js -- whichever file loads first defines
     it. A colorway swatch click repaints the price, so the repaint has to run
     the identical rule or a MAP-restricted variant leaks its number the moment
     someone clicks a dot. See algolia-2026.js for the full rationale. */
  var mapGuard = window.__spidMapGuard || (function () {
    function num(v) {
      if (v == null) return 0;
      var n = parseFloat(String(v).replace(/[^0-9.\-]/g, ''));
      return (isFinite(n) && n > 0) ? n : 0;
    }
    function mapOf(hit) {
      var m = hit && hit.meta && hit.meta.c_f;
      return m ? num(m.map) : 0;
    }
    function tagged(hit) {
      var t = (hit && (hit.tags || hit._tags)) || [];
      if (typeof t === 'string') { t = [t]; }
      for (var i = 0; i < t.length; i++) {
        if (String(t[i]).toLowerCase() === 'hide_searchanise_price') return true;
      }
      return false;
    }
    /* Configure-to-price: no usable positive price (the FPD custom-lanyard
       products sit at 0.00 by design). Mirrors configurable() in
       assets/algolia-2026.js. */
    function configurable(hit, price) {
      var p = Number(price == null ? (hit && hit.price) : price);
      return !(isFinite(p) && p > 0);
    }
    function hide(hit, price) {
      var p = Number(price == null ? (hit && hit.price) : price);
      var m = mapOf(hit);
      /* No usable selling price: configure-to-price. Withhold regardless. */
      if (!(isFinite(p) && p > 0)) return true;
      /* A usable MAP settles it by itself -- hide ONLY when MAP is strictly
         above the selling price. The tag is a fallback for records with no
         MAP at all. Mirrors hide() in assets/algolia-2026.js. */
      if (m > 0) return p < m;
      return tagged(hit);
    }
    function ctaLabel(hit, price) {
      return configurable(hit, price) ? 'Design & See Price' : 'Add to Cart for Price';
    }
    /* The MAP value we are allowed to PRINT as the struck-through "was" price.
       (2026-07-28) 63 tagged products are priced exactly AT their MAP, so
       printing the MAP would print the very number we were told to withhold.
       Only a MAP strictly above the selling price is renderable.
       Mirrors strikeMap() in assets/algolia-2026.js. */
    function strikeMap(hit, price) {
      var m = mapOf(hit);
      var p = Number(price == null ? (hit && hit.price) : price);
      return (m > 0 && isFinite(p) && p > 0 && m > p) ? m : 0;
    }
    function ctaHtml(mapValue, label) {
      return (mapValue > 0 ? '<s>' + money(mapValue) + '</s>' : '') +
        '<b class="h26-card__cta">' + (label || 'Add to Cart for Price') + '</b>';
    }
    return { num: num, mapOf: mapOf, tagged: tagged, hide: hide, ctaHtml: ctaHtml, strikeMap: strikeMap, configurable: configurable, ctaLabel: ctaLabel };
  })();
  window.__spidMapGuard = mapGuard;

  function sizedImg(url) { if (!url) return url; return url.split('?')[0] + '?width=360'; }

  /* ---------- the app's searchClient request shape (MEASURED 2026-08-19) ----------
     window.algoliaShopify.searchClient is an InstantSearch-compatible ADAPTER,
     not the raw Algolia client. Measured on the live storefront with the App
     Block Search client version set to **Version 5**:

       client.search([{ indexName: 'x', params: { query: 'q' } }])   -> OK
       client.search({ requests: [{ indexName: 'x', query: 'q' }] })  -> FAILS
                                                 ("Expecting a string")

     So the underlying library moved v4 -> v5, but this adapter deliberately
     keeps the LEGACY ARRAY signature, because that is what InstantSearch hands
     it. DO NOT "modernise" these calls to the v5 {requests:[...]} form — it
     breaks colourway swatches and the colour-family row.

     Do not version-sniff here either. The v5 client the app injects drops
     initIndex/multipleQueries and exposes searchForHits — but NOT
     searchSingleIndex — so every obvious probe gives the wrong answer. The
     request shape is the contract; the library version behind it is not our
     business. */
  function clientSearch(client, indexName, params) {
    return client.search([{ indexName: indexName, params: params }]);
  }

  function getIS() {
    var S = window.algoliaShopify;
    var is = S && S.instantsearch && S.instantsearch.search;
    if (!is || !is.helper || !S.searchClient) return null;
    return is;
  }
  function currentSig(is) {
    try {
      var q = is.helper.getQuery();
      return JSON.stringify([q.query || '', q.facetFilters || [], q.numericFilters || [], q.filters || '', q.tagFilters || []]);
    } catch (e) { return null; }
  }
  function buildColorways(records) {
    var seen = {}, list = [];
    records.forEach(function (h) {
      var c = (h.options || {}).color; if (!c || seen[c]) return; seen[c] = 1;
      list.push({ color: c, vid: h.objectID, pos: Number(h.position || 999), price: Number(h.price), cmp: Number(h.compare_at_price || 0), image: h.image || h.product_image || '', sku: h.sku || '', map: mapGuard.strikeMap(h, h.price), hide: mapGuard.hide(h, h.price), cta: (mapGuard.ctaLabel ? mapGuard.ctaLabel(h, h.price) : 'Add to Cart for Price') });
    });
    /* popularity order: variant position is the store's 12-mo sales ranking
       (2026-07 variant reorder) — the visible dots should be the top sellers,
       not a fixed color-catalog order that buried e.g. Blue behind "+12" */
    list.sort(function (a, b) { if (a.pos !== b.pos) return a.pos - b.pos; var ra = colorRank(a.color), rb = colorRank(b.color); if (ra !== rb) return ra - rb; return a.color < b.color ? -1 : 1; });
    return list;
  }
  function fetchEnrichment(is, cb) {
    var sig = currentSig(is); if (!sig) { cb(null); return; }
    if (enrichCache[sig]) { cb(enrichCache[sig]); return; }
    if (enriching[sig]) return;
    enriching[sig] = true;
    var S = window.algoliaShopify, base;
    try { base = is.helper.getQuery(); } catch (e) { enriching[sig] = false; cb(null); return; }
    var params = assign({}, base);
    params.distinct = 0; params.page = 0; params.hitsPerPage = 1000;
    /* 'meta' and 'tags' feed the MAP guard -- without them every swatch repaint
       would look like an unrestricted product and print the price. */
    params.attributesToRetrieve = ['objectID', 'handle', 'options', 'price', 'compare_at_price', 'image', 'product_image', 'sku', 'position', 'meta', 'tags'];
    params.attributesToHighlight = []; params.responseFields = ['hits'];
    /* helper query, not a shopper search: keep it out of Algolia analytics and skip the facet counts */
    params.analytics = false; params.clickAnalytics = false; params.facets = [];
    clientSearch(S.searchClient, is.indexName, params).then(function (res) {
      var hits = (res && res.results && res.results[0] && res.results[0].hits) || [];
      var byH = {}, colors = {};
      hits.forEach(function (h) { var k = h.handle; if (k) { (byH[k] = byH[k] || []).push(h); } var c = (h.options || {}).color; if (c) colors[c] = 1; });
      var map = {};
      for (var k in byH) { if (Object.prototype.hasOwnProperty.call(byH, k)) map[k] = buildColorways(byH[k]); }
      enrichCache[sig] = { map: map, colors: colors }; enriching[sig] = false; cb(enrichCache[sig]);
    }, function () { enriching[sig] = false; cb(null); });
  }

  function handleFromCard(a) { var h = (a.getAttribute('href') || '').split('/products/')[1]; return h ? h.split('?')[0].split('#')[0] : null; }
  function vidFromCard(a) { var m = (a.getAttribute('href') || '').match(/[?&]variant=(\d+)/); return m ? m[1] : null; }

  function renderPrice(priceEl, cw) {
    /* MAP-restricted colorway: struck MAP + CTA, never the number, and return 0
       so updateBadge() strips the "% OFF" tease along with it. */
    if (cw.hide) {
      priceEl.className = 'h26-card__price h26-card__price--map';
      priceEl.setAttribute('data-hide-price', '1');
      priceEl.setAttribute('data-map', cw.map || '');
      priceEl.innerHTML = mapGuard.ctaHtml(cw.map, cw.cta);
      return 0;
    }
    priceEl.className = 'h26-card__price';
    priceEl.removeAttribute('data-hide-price');
    priceEl.removeAttribute('data-map');
    var pct = (cw.cmp > cw.price && cw.cmp > 0) ? Math.round((1 - cw.price / cw.cmp) * 100) : 0;
    var html = '<b class="' + (pct > 0 ? 'sale' : '') + '">' + money(cw.price) + '</b>';
    if (pct > 0) { html += '<s>' + money(cw.cmp) + '</s><em>-' + pct + '%</em>'; }
    priceEl.innerHTML = html;
    return pct;
  }
  function updateBadge(card, pct) {
    var badge = card.querySelector('.h26-card__badge');
    if (pct > 0) {
      if (!badge) { badge = document.createElement('span'); badge.className = 'h26-card__badge'; card.insertBefore(badge, card.firstChild); }
      badge.textContent = pct + '% OFF';
    } else if (badge) { badge.parentNode.removeChild(badge); }
  }
  function applyColorway(card, cw) {
    var img = card.querySelector('.h26-card__img');
    if (img && cw.image) { img.removeAttribute('srcset'); img.src = sizedImg(cw.image); }
    var priceEl = card.querySelector('.h26-card__price');
    var pct = priceEl ? renderPrice(priceEl, cw) : 0;
    updateBadge(card, pct);
    var skuEl = card.querySelector('.h26-card__sku');
    if (skuEl && cw.sku) {
      /* raw SKU stays in data-sku (that is what colorway matching compares);
         the visible line is the normalised "#..." part number. */
      skuEl.setAttribute('data-sku', cw.sku);
      skuEl.textContent = '#' + pnDisp(cw.sku, card.getAttribute('data-vendor'));
    }
    var handle = handleFromCard(card);
    if (handle) { card.setAttribute('href', '/products/' + handle + '?variant=' + cw.vid); }
  }
  function selectSwatch(row, el) {
    var kids = row.querySelectorAll('.spid-swatch');
    for (var i = 0; i < kids.length; i++) kids[i].classList.remove('spid-swatch--sel');
    if (el) el.classList.add('spid-swatch--sel');
  }

  /* colorway the current search query asks for (color-intent), if this
     product has it — e.g. query "yellow badge holder" -> the Yellow (or
     Neon/Translucent Yellow) colorway of every card that offers one. */
  function queryColorway(colorways) {
    var is = getIS(); if (!is) return null;
    var q = null;
    try { q = is.helper.state.query; } catch (e) { return null; }
    var groups = colorFiltersFor(q); if (!groups) return null;
    for (var g = 0; g < groups.length; g++) {
      for (var n = 0; n < groups[g].length; n++) {
        var name = groups[g][n].split(':').slice(1).join(':');
        for (var c = 0; c < colorways.length; c++) { if (colorways[c].color === name) return colorways[c]; }
      }
    }
    return null;
  }

  var MAXDOTS = 8;
  function injectCard(card, colorways) {
    if (card.getAttribute('data-spid-cards') === '1') return;
    card.setAttribute('data-spid-cards', '1');
    if (!colorways || colorways.length < 2) return;
    var body = card.querySelector('.h26-card__body') || card;
    var row = document.createElement('div'); row.className = 'spid-card-swatches';
    var curVid = vidFromCard(card);
    /* bugfix (2026-07-25): first render often has NO ?variant= in the card
       link, so curVid was null, no dot matched, and the fallback repainted
       EVERY card to the first dot of the old color-catalog order (= Black) —
       overriding the ranked hit (custom buddies showed Black over Blue).
       Identify the hit's colorway by the SKU the template rendered. */
    if (!curVid) {
      var skuEl0 = card.querySelector('.h26-card__sku');
      /* 2026-07-26: the visible line is now the normalised "#..." part number,
         so match on data-sku (the raw SKU the template stashed). The stripped
         textContent is only a fallback for DOM rendered by an older template. */
      var skuTxt = skuEl0 ? (skuEl0.getAttribute('data-sku') || skuEl0.textContent.replace(/^#/, '')).trim() : '';
      if (skuTxt) {
        for (var si = 0; si < colorways.length; si++) {
          if (colorways[si].sku === skuTxt) { curVid = colorways[si].vid; break; }
        }
      }
    }
    /* color-intent query: front the queried colorway on this card (the app's
       hits renderer can serve pre-boost DOM, so we enforce it card-side) */
    var qcw = queryColorway(colorways);
    if (qcw) {
      if (String(qcw.vid) !== String(curVid)) applyColorway(card, qcw);
      curVid = qcw.vid;
    }
    var shown = colorways.slice(0, MAXDOTS);
    /* bugfix: if the loaded variant's colorway is beyond the first MAXDOTS,
       swap it into the last visible slot so the selected dot matches the
       image shown on load (was: green image + black dot marked selected) */
    if (curVid && shown.length === MAXDOTS && colorways.length > MAXDOTS) {
      var curShown = false, ci;
      for (ci = 0; ci < shown.length; ci++) { if (String(shown[ci].vid) === String(curVid)) { curShown = true; break; } }
      if (!curShown) {
        for (ci = MAXDOTS; ci < colorways.length; ci++) {
          if (String(colorways[ci].vid) === String(curVid)) { shown[MAXDOTS - 1] = colorways[ci]; break; }
        }
      }
    }
    shown.forEach(function (cw) {
      var sw = makeSwatch(cw.color);
      sw.setAttribute('role', 'button'); sw.setAttribute('aria-label', cw.color); sw.title = cw.color;
      if (curVid && String(cw.vid) === String(curVid)) sw.className += ' spid-swatch--sel';
      sw.addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        applyColorway(card, cw); selectSwatch(row, sw);
        /* bugfix: hide the hover second-image overlay so the newly chosen
           color is visible immediately (it re-arms on the next hover) */
        var ho = card.querySelector('.spid-hover-img');
        if (ho) ho.classList.remove('spid-hi-ready');
      });
      row.appendChild(sw);
    });
    if (colorways.length > MAXDOTS) {
      var more = document.createElement('span');
      more.className = 'spid-card-more';
      more.textContent = '+' + (colorways.length - MAXDOTS);
      more.title = (colorways.length - MAXDOTS) + ' more colors';
      row.appendChild(more);
    }
    /* bugfix: if nothing matched the loaded variant, sync image AND selection
       to the first swatch instead of marking a dot that doesn't match the photo */
    if (!row.querySelector('.spid-swatch--sel')) {
      var f = row.querySelector('.spid-swatch');
      if (f) { f.className += ' spid-swatch--sel'; applyColorway(card, shown[0]); }
    }
    body.appendChild(row);
  }

  function enrichCards() {
    var is = getIS(); if (!is) return;
    var cards = document.querySelectorAll('.h26-card'); if (!cards.length) return;
    var pending = false;
    for (var i = 0; i < cards.length; i++) { if (cards[i].getAttribute('data-spid-cards') !== '1') { pending = true; break; } }
    if (!pending) return;
    fetchEnrichment(is, function (entry) {
      if (!entry) return;
      var cs = document.querySelectorAll('.h26-card');
      for (var j = 0; j < cs.length; j++) {
        var a = cs[j]; if (a.getAttribute('data-spid-cards') === '1') continue;
        var h = handleFromCard(a); injectCard(a, h ? entry.map[h] : null);
      }
    });
  }

  /* ================= COLOR-FAMILY QUICK-PICK ================= */
  /* Complete, disjunctive-correct set of colours available for the current
     NON-colour filter context (so the family row stays full after you pick a
     colour, and isn't capped at the facet's display limit). */
  var colorUniverse = {}, universeFetching = {};
  function stripColorFF(ff) {
    if (!ff) return ff;
    return ff.filter(function (e) {
      if (typeof e === 'string') return e.indexOf('options.color:') !== 0;
      if (Array.isArray(e)) return !(e.length && String(e[0]).indexOf('options.color:') === 0);
      return true;
    });
  }
  function nonColorSig(is) {
    try { var q = is.helper.getQuery(); return JSON.stringify([q.query || '', stripColorFF(q.facetFilters) || [], q.numericFilters || [], q.filters || '', q.tagFilters || []]); }
    catch (e) { return null; }
  }
  function fetchColorUniverse(is) {
    var sig = nonColorSig(is); if (!sig || colorUniverse[sig] || universeFetching[sig]) return;
    universeFetching[sig] = true;
    var S = window.algoliaShopify, base;
    try { base = is.helper.getQuery(); } catch (e) { universeFetching[sig] = false; return; }
    var p = assign({}, base);
    p.facetFilters = stripColorFF(base.facetFilters);
    p.facets = ['options.color']; p.maxValuesPerFacet = 200; p.hitsPerPage = 0;
    p.attributesToRetrieve = []; p.attributesToHighlight = []; p.responseFields = ['facets'];
    p.analytics = false; p.clickAnalytics = false;
    clientSearch(S.searchClient, is.indexName, p).then(function (res) {
      var f = (res && res.results && res.results[0] && res.results[0].facets && res.results[0].facets['options.color']) || {};
      var set = {}; for (var k in f) { if (Object.prototype.hasOwnProperty.call(f, k)) set[k] = 1; }
      colorUniverse[sig] = set; universeFetching[sig] = false;
    }, function () { universeFetching[sig] = false; });
  }
  /* The grid's own query already requests options.color as a DISJUNCTIVE facet, and a
     disjunctive facet's counts deliberately ignore that facet's own refinements - which is
     exactly the "colour universe with the colour filters stripped" this row needs. So read it
     off lastResults instead of paying Algolia for a second query (SPID-328: that query was one
     of three per collection view, and collection views are the bulk of the bill).

     Measured on live 2026-10-07, /collections/badge-buddies: 22 colours listed before any
     refinement; after refining Blue the list was still all 22 (Blue flagged isRefined) while
     nbHits fell 365 -> 71. Same answer the dedicated query gives, for free.

     Two cases still need the old query, so it stays as the fallback: the facet is not
     configured on this surface (nothing to read), or the value list is capped by
     maxValuesPerFacet and may therefore be truncated - the dedicated query asks for 200.
     Truncation is only possible when the list is AT the cap, so that is the test.

     The app's own cap is 25 on a collection and 10 on /search, which any surface with more
     colours than that hits every time, so the cap is raised to 200 by an inline <head> hook
     in layout/theme.liquid (SPID-328). It cannot be raised from this file: the app
     initialises and fires its first query before any theme asset runs, and the client this
     file patches is not the one InstantSearch uses (verified on live 2026-10-07 - zero
     InstantSearch calls went through it). */
  function colorsFromResults(is) {
    try {
      var lr = is && is.helper && is.helper.lastResults; if (!lr) return null;
      var vals = lr.getFacetValues('options.color');
      var arr = Array.isArray(vals) ? vals : (vals && vals.data) || null;
      if (!arr || !arr.length) return null;
      var cap = (is.helper.state && is.helper.state.maxValuesPerFacet) || 0;
      if (cap && arr.length >= cap) return null;   /* possibly truncated - let the query run */
      var set = {};
      for (var i = 0; i < arr.length; i++) { if (arr[i] && arr[i].name) set[arr[i].name] = 1; }
      return set;
    } catch (e) { return null; }
  }
  function availableColors(is) {
    var sig = nonColorSig(is);
    if (sig && colorUniverse[sig]) return colorUniverse[sig];
    var fromResults = colorsFromResults(is);
    if (fromResults) { if (sig) colorUniverse[sig] = fromResults; return fromResults; }
    return null;
  }
  function colorRefs(is) {
    try { return is.helper.getRefinements('options.color').map(function (r) { return r.value; }); } catch (e) { return []; }
  }
  function famMembersIn(fam, avail) {
    var out = []; fam.members.forEach(function (m) { if (avail[m]) out.push(m); }); return out;
  }
  function toggleFamily(is, fam) {
    var refs = {}; colorRefs(is).forEach(function (v) { refs[v] = 1; });
    var refinedMembers = fam.members.filter(function (m) { return refs[m]; });
    var h = is.helper;
    if (refinedMembers.length) {
      refinedMembers.forEach(function (m) { h.removeDisjunctiveFacetRefinement('options.color', m); });
    } else {
      var avail = availableColors(is) || {};
      var toAdd = famMembersIn(fam, avail);
      if (!toAdd.length) return;
      toAdd.forEach(function (m) { h.addDisjunctiveFacetRefinement('options.color', m); });
    }
    h.search();
  }
  function famSwatch(fam) {
    var s = document.createElement('span');
    s.className = 'spid-swatch'; s.style.background = fam.hex;
    if (fam.key === 'Clear' || fam.key === 'White') s.className += ' spid-swatch--trans';
    return s;
  }
  function colorPanelBody() {
    var wraps = document.querySelectorAll('[class*="ais-facet-options.color"]');
    for (var i = 0; i < wraps.length; i++) {
      var b = wraps[i].querySelector('.ais-Panel-body') || wraps[i].querySelector('.ais-facet-dropdown-container');
      if (b) return b;
    }
    return null;
  }
  function buildFamilyRow(is) {
    var body = colorPanelBody(); if (!body) return;
    if (body.querySelector('.spid-fam-row')) { syncFamilies(is); return; }
    var avail = availableColors(is);
    if (!avail) {
      /* No results in hand yet means "come back next tick", NOT "pay for a query". Our tick
         can run before the grid's own response lands - measured on live 2026-10-07, the grid
         query started at 1115ms and answered around 1422ms while this ran at 1173ms - and the
         facets we want arrive WITH that response. Falling back there spent the query this
         change exists to avoid, and the live page still showed three requests. tick() re-runs
         on every DOM mutation (debounced 160ms) plus an 800ms interval, so the grid rendering
         its results brings us straight back here with lastResults populated.
         Only pay when results ARE in and still cannot answer: facet not configured on this
         surface, or capped at maxValuesPerFacet and possibly truncated. */
      if (is && is.helper && is.helper.lastResults) fetchColorUniverse(is);
      return;
    }
    if (!Object.keys(avail).length) return;
    var wrap = document.createElement('div'); wrap.className = 'spid-fam-wrap';
    var row = document.createElement('div'); row.className = 'spid-fam-row';
    FAMILIES.forEach(function (fam) {
      if (!famMembersIn(fam, avail).length) return; /* only families with in-stock shades */
      var chip = document.createElement('button');
      chip.type = 'button'; chip.className = 'spid-fam'; chip.setAttribute('data-fam', fam.key);
      chip.title = fam.key; chip.setAttribute('aria-label', fam.key);
      chip.appendChild(famSwatch(fam));
      chip.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); toggleFamily(is, fam); });
      row.appendChild(chip);
    });
    if (!row.children.length) return;
    wrap.appendChild(row);
    /* expandable exact-shade list (labeled rows, on demand) */
    var names = Object.keys(avail).sort(function (a, b) { var ra = colorRank(a), rb = colorRank(b); if (ra !== rb) return ra - rb; return a < b ? -1 : 1; });
    if (names.length > 1) {
      var toggle = document.createElement('button');
      toggle.type = 'button'; toggle.className = 'spid-shades-toggle';
      toggle.appendChild(document.createTextNode('All colors'));
      var shades = document.createElement('div'); shades.className = 'spid-shades';
      names.forEach(function (name) {
        var r = document.createElement('button'); r.type = 'button'; r.className = 'spid-shade'; r.setAttribute('data-color', name);
        r.appendChild(makeSwatch(name));
        var t = document.createElement('span'); t.className = 'spid-shade-name'; t.textContent = name; r.appendChild(t);
        r.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); toggleColor(is, name); });
        shades.appendChild(r);
      });
      toggle.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); wrap.classList.toggle('spid-shades-open'); });
      wrap.appendChild(toggle); wrap.appendChild(shades);
    }
    body.insertBefore(wrap, body.firstChild);
    syncFamilies(is);
  }
  function toggleColor(is, name) {
    var refs = {}; colorRefs(is).forEach(function (v) { refs[v] = 1; });
    var h = is.helper;
    if (refs[name]) h.removeDisjunctiveFacetRefinement('options.color', name);
    else h.addDisjunctiveFacetRefinement('options.color', name);
    h.search();
  }
  function syncFamilies(is) {
    var refs = {}; colorRefs(is).forEach(function (v) { refs[v] = 1; });
    var row = document.querySelector('.spid-fam-row');
    if (row) {
      var chips = row.querySelectorAll('.spid-fam');
      for (var i = 0; i < chips.length; i++) {
        var key = chips[i].getAttribute('data-fam');
        var fam = null; for (var j = 0; j < FAMILIES.length; j++) { if (FAMILIES[j].key === key) { fam = FAMILIES[j]; break; } }
        var on = fam && fam.members.some(function (m) { return refs[m]; });
        if (on) chips[i].classList.add('spid-fam--on'); else chips[i].classList.remove('spid-fam--on');
      }
    }
    var srows = document.querySelectorAll('.spid-shade');
    for (var k = 0; k < srows.length; k++) {
      var nm = srows[k].getAttribute('data-color');
      if (refs[nm]) srows[k].classList.add('spid-shade--on'); else srows[k].classList.remove('spid-shade--on');
    }
  }
  function familiesTick() {
    var is = getIS(); if (!is) return;
    try { buildFamilyRow(is); } catch (e) {}
  }

  /* ================= COLOR-INTENT QUERY BOOST ================= */
  /* "yellow badge holder" should FRONT the yellow colorway on every card.
     options.color is a searchable attribute (recall); this adds Algolia
     optionalFilters (the "filters" ranking criterion — beats proximity/
     attribute/sales ties) so the matching colorway wins each product's
     distinct group. Family words (yellow, blue...) boost all their shades.
     Implemented by patching the app's searchClient once (applies to
     instantsearch, autocomplete, and replica sort requests alike). */
  var COLORKEYS = {};   /* lowercased color/family word -> [exact shade names] */
  (function buildColorKeys() {
    for (var name in MAP) { if (Object.prototype.hasOwnProperty.call(MAP, name)) COLORKEYS[name.toLowerCase()] = [name]; }
    FAMILIES.forEach(function (f) {
      var k = f.key.toLowerCase();
      var merged = (COLORKEYS[k] || []).concat(f.members);
      COLORKEYS[k] = merged.filter(function (v, i, a) { return a.indexOf(v) === i; });
    });
    delete COLORKEYS['custom'];   /* "custom badge buddy" = custom printing, not the Custom colorway */
  })();
  function colorFiltersFor(query) {
    if (!query) return null;
    var words = String(query).toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').split(/\s+/).filter(Boolean);
    var groups = [], used = {};
    for (var i = 0; i < words.length; i++) {
      var two = i + 1 < words.length ? words[i] + ' ' + words[i + 1] : null;
      var key = (two && COLORKEYS[two]) ? two : (COLORKEYS[words[i]] ? words[i] : null);
      if (!key || used[key]) continue;
      used[key] = 1;
      groups.push(COLORKEYS[key].map(function (n) { return 'options.color:' + n; }));
      if (key === two) i++;
    }
    return groups.length ? groups : null;
  }
  function boostHelper(helper) {
    var want = colorFiltersFor(helper.state.query) || undefined;
    if (JSON.stringify(want) !== JSON.stringify(helper.state.optionalFilters)) {
      helper.setQueryParameter('optionalFilters', want);
      return true;
    }
    return false;
  }
  /* Primary path: app hook — searchFunction runs before EVERY instantsearch
     query (including the first), so the landing render is already boosted. */
  function registerColorHook() {
    var S = window.algoliaShopify;
    if (!S || !S.hooks || window.__spidColorHooked) return;
    try {
      S.hooks.registerHook('beforeInstantSearchOptions', function (opts) {
        opts = opts || {};
        var prev = opts.searchFunction;
        opts.searchFunction = function (helper) {
          try { boostHelper(helper); } catch (e) {}
          if (prev) { prev(helper); } else { helper.search(); }
        };
        return opts;
      });
      window.__spidColorHooked = 1;
    } catch (e) {}
  }
  registerColorHook();
  document.addEventListener('algolia.hooks.initialize', registerColorHook);
  function patchClient(client) {
    if (!client || client.__spidColorBoost || typeof client.search !== 'function') return false;
    var orig = client.search.bind(client);
    /* This wrapper sits in front of EVERY search the app makes (autocomplete,
       instantsearch, replica sorts), so it must never corrupt a request it does
       not understand. Today the adapter always hands us an ARRAY of
       {indexName, params} — measured under both client v4 and v5 on 2026-08-19.
       A {requests:[...]} object is tolerated too, so that if the adapter ever
       changes shape this degrades to "no colour boost" rather than breaking
       search outright. Anything else passes straight through untouched. */
    client.search = function (a) {
      var rest = Array.prototype.slice.call(arguments, 1);
      try {
        var list = Array.isArray(a) ? a : (a && Array.isArray(a.requests) ? a.requests : null);
        if (list) {
          list.forEach(function (req) {
            if (!req || String(req.indexName || '').indexOf('shopify_products') !== 0) return;
            if (typeof req.params === 'string') return;
            /* adapter form: params nested under req.params. flattened form: on req itself. */
            var p = req.params;
            if (!p || typeof p !== 'object') {
              p = ('query' in req || 'hitsPerPage' in req || 'facets' in req) ? req : (req.params = {});
            }
            if (p.optionalFilters) return;
            /* instantsearch nests query in params; autocomplete puts it on the request */
            var q = typeof p.query === 'string' ? p.query : req.query;
            var of = colorFiltersFor(q);
            if (of) p.optionalFilters = of;
          });
        }
      } catch (e) {}
      return orig.apply(null, [a].concat(rest));
    };
    client.__spidColorBoost = 1;
    return true;
  }
  function patchSearchClient() {
    var S = window.algoliaShopify;
    if (!S) return;
    patchClient(S.searchClient);   /* autocomplete + our enrichment queries */
    /* instantsearch: the boost must live in HELPER STATE, not the client —
       the app's hits widget caches rendered hits keyed by widget state, so a
       client-level param injection returns new hits that never re-render. */
    var is = S.instantsearch && S.instantsearch.search;
    if (is && is.helper && !is.__spidColorState) {
      is.__spidColorState = 1;
      var wanted = function () { return colorFiltersFor(is.helper.state.query) || undefined; };
      is.helper.on('change', function () {
        try {
          var want = wanted();
          if (JSON.stringify(want) !== JSON.stringify(is.helper.state.optionalFilters)) {
            is.helper.setQueryParameter('optionalFilters', want);
          }
        } catch (e) {}
      });
      try {   /* boost the landing query (one extra search only when it has color intent) */
        var want0 = wanted();
        if (JSON.stringify(want0) !== JSON.stringify(is.helper.state.optionalFilters)) {
          is.helper.setQueryParameter('optionalFilters', want0);
          is.helper.search();
        }
      } catch (e) {}
    }
  }

  /* ================= HOVER: SECOND PRODUCT IMAGE ================= */
  /* On first hover, fetch /products/<handle>.js (Shopify CDN-cached JSON),
     pick the first gallery image that is NOT a colorway/variant image and
     not the one already shown, and crossfade it in. Products whose gallery
     is only colorway shots don't flip (card swatches cover those). */
  var hoverAlt = {};      /* handle -> url or null (fetched, none suitable) */
  var hoverFetching = {};
  function normUrl(u) { if (u && u.indexOf('//') === 0) return 'https:' + u; return u; }
  function bpath(u) { return (u || '').split('?')[0].replace(/^https?:/, ''); }
  function pickAlt(p, curSrc) {
    var imgs = (p && p.images) || []; if (imgs.length < 2) return null;
    var vset = {}, skus = {};
    (p.variants || []).forEach(function (v) {
      if (v.featured_image && v.featured_image.src) vset[bpath(v.featured_image.src)] = 1;
      if (v.sku) skus[String(v.sku).toLowerCase()] = 1;
    });
    var cur = bpath(curSrc);
    for (var i = 0; i < imgs.length; i++) {
      var b = bpath(imgs[i]);
      if (b === cur || vset[b]) continue;
      var fn = b.split('/').pop().replace(/\.[a-z0-9]+$/i, '');
      try { fn = decodeURIComponent(fn); } catch (e) {}
      if (skus[fn.toLowerCase()]) continue; /* colorway image named after a variant SKU */
      return normUrl(imgs[i]);
    }
    return null;
  }
  function applyHover(card, url) {
    if (!url) return;
    var o = card.querySelector('.spid-hover-img');
    if (!o) {
      o = document.createElement('img');
      o.className = 'spid-hover-img'; o.alt = ''; o.setAttribute('aria-hidden', 'true');
      card.appendChild(o);
    }
    var want = sizedImg(url);
    if (o.getAttribute('src') !== want) {
      o.classList.remove('spid-hi-ready');
      o.onload = function () { o.classList.add('spid-hi-ready'); };
      o.src = want;
    } else if (o.complete) {
      /* re-arm after a swatch click hid the overlay (same src, already loaded) */
      o.classList.add('spid-hi-ready');
    }
  }
  function attachHover(card) {
    if (card.getAttribute('data-spid-hover') === '1') return;
    card.setAttribute('data-spid-hover', '1');
    card.addEventListener('mouseenter', function () {
      var h = handleFromCard(card); if (!h) return;
      if (Object.prototype.hasOwnProperty.call(hoverAlt, h)) { applyHover(card, hoverAlt[h]); return; }
      if (hoverFetching[h]) return;
      hoverFetching[h] = 1;
      fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        var img = card.querySelector('.h26-card__img');
        hoverAlt[h] = p ? pickAlt(p, img ? img.src : '') : null;
        hoverFetching[h] = 0;
        applyHover(card, hoverAlt[h]);
      }).catch(function () { hoverFetching[h] = 0; hoverAlt[h] = null; });
    });
  }
  function hoverTick() {
    var cs = document.querySelectorAll('.h26-card');
    for (var i = 0; i < cs.length; i++) attachHover(cs[i]);
  }

  /* ================= STYLES ================= */
  var css = ''
    + '.ais-RefinementList-label.spid-has-swatch{display:flex;align-items:center;}'
    + '.spid-swatch{display:inline-block;flex:0 0 auto;width:16px;height:16px;border-radius:50%;'
    + 'margin-right:8px;vertical-align:middle;box-shadow:inset 0 0 0 1px rgba(0,0,0,.28);background-size:cover;background-position:center;}'
    + '.spid-swatch--trans{position:relative;}'
    + '.spid-swatch--trans:after{content:"";position:absolute;inset:0;border-radius:50%;'
    + 'background:linear-gradient(135deg,rgba(255,255,255,.6),rgba(255,255,255,.05) 60%);}'
    + '.spid-swatch--unknown{background:conic-gradient(#ddd,#bbb,#ddd);}'
    + '.spid-card-swatches{display:flex;flex-wrap:wrap;gap:5px;margin:7px 0 1px;align-items:center;}'
    + '.spid-card-swatches .spid-swatch{width:17px;height:17px;margin:0;cursor:pointer;transition:transform .12s ease;}'
    + '.spid-card-swatches .spid-swatch:hover{transform:scale(1.18);}'
    + '.spid-card-swatches .spid-swatch--sel{box-shadow:inset 0 0 0 1px rgba(0,0,0,.28),0 0 0 2px #fff,0 0 0 3.5px #3d6720;}'
    + '.spid-card-more{font:600 11px/1 "Inter",system-ui,sans-serif;color:#666;margin-left:1px;align-self:center;white-space:nowrap;}'
    /* Color facet rendered as a clean grid of colour circles */
    + '.spid-fam-wrap{margin:2px 0 4px;padding:0;}'
    + '.spid-fam-row{display:flex;flex-wrap:wrap;gap:10px;}'
    + '.spid-fam{padding:0;margin:0;border:0;background:none;cursor:pointer;line-height:0;border-radius:50%;-webkit-appearance:none;appearance:none;}'
    + '.spid-fam .spid-swatch{width:28px;height:28px;margin:0;box-shadow:inset 0 0 0 1px rgba(0,0,0,.22);transition:transform .12s ease;}'
    + '.spid-fam:hover .spid-swatch{transform:scale(1.08);}'
    + '.spid-fam--on .spid-swatch{box-shadow:inset 0 0 0 1px rgba(0,0,0,.22),0 0 0 2px #fff,0 0 0 3px #70B040;}'
    /* Color facet: swatch grid only — hide the app search box + exact-shade checkbox list */
    + '.ais-facet-options\\.color .ais-Panel-body > div:not(.spid-fam-wrap){display:none !important;}'
    /* expandable "All colors" labeled shade list */
    + '.spid-shades-toggle{margin:12px 0 0;padding:0;border:0;background:none;cursor:pointer;display:inline-flex;align-items:center;gap:6px;'
    + 'font:600 12px/1 "Inter",system-ui,sans-serif;letter-spacing:.02em;color:#3d6720;}'
    + '.spid-shades-toggle:after{content:"+";font-size:15px;line-height:1;font-weight:700;}'
    + '.spid-shades-open .spid-shades-toggle:after{content:"\\2013";}'
    + '.spid-shades{display:none;margin:9px 0 2px;}'
    + '.spid-shades-open .spid-shades{display:block;}'
    + '.spid-shade{display:flex;align-items:center;gap:9px;width:100%;padding:5px 7px;border:0;background:none;cursor:pointer;text-align:left;'
    + 'border-radius:7px;font:500 13px/1.3 "Inter",system-ui,sans-serif;color:#33332e;-webkit-appearance:none;appearance:none;}'
    + '.spid-shade:hover{background:#f4f4f0;}'
    + '.spid-shade .spid-swatch{width:16px;height:16px;margin:0;}'
    + '.spid-shade-name{flex:1 1 auto;}'
    + '.spid-shade--on{color:#2c5017;font-weight:700;}'
    + '.spid-shade--on:after{content:"\\2713";color:#70B040;font-weight:700;font-size:12px;}'
    /* hover second-image flip */
    + '.spid-hover-img{position:absolute;top:0;left:0;width:100%;aspect-ratio:1/1;object-fit:contain;'
    + 'background:#fff;padding:14px;box-sizing:border-box;border-bottom:1px solid #eeeee9;'
    + 'opacity:0;transition:opacity .22s ease;pointer-events:none;z-index:1;}'
    + '.h26-card:hover .spid-hover-img.spid-hi-ready{opacity:1;}'
    + '@media (hover:none){.spid-hover-img{display:none;}}';

  /* ================= INIT ================= */
  function tick() { try { patchSearchClient(); decorate(); enrichCards(); familiesTick(); hoverTick(); } catch (e) {} }
  function init() {
    if (!document.getElementById('spid-swatch-css')) {
      var st = document.createElement('style'); st.id = 'spid-swatch-css'; st.textContent = css; document.head.appendChild(st);
    }
    tick();
    var pending = false;
    function schedule() { if (pending) return; pending = true; setTimeout(function () { pending = false; tick(); }, 160); }
    if (window.MutationObserver) { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); }
    var n = 0, iv = setInterval(function () { tick(); if (++n >= 10) clearInterval(iv); }, 800);
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
